module.exports = {
  strings: {
    pluginNameDropbox: 'Dropbox'
  }
};